import Collection from 'girder/collections/Collection';
import { SORT_DESC } from 'girder/constants';

import AnnotationModel from '../models/AnnotationModel';

export default Collection.extend({
    resourceName: 'annotation',
    model: AnnotationModel,
    pageLimit: 100,
    sortField: 'created',
    sortDir: SORT_DESC
});



// WEBPACK FOOTER //
// ./plugins/large_image/web_client/collections/AnnotationCollection.js